export default "__VITE_ASSET__DtzYt2U0__"